module.exports = __webpack_public_path__ + "img/ic_tripadvisor-0.5.716dcea1.svg";